import { useState, useRef } from "react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { getBirthdays } from "../../lib/api";
import { printRef } from "../../lib/print";
import PrintableGroupLists from "../PrintableGroupLists";
import PrintableGradeRoster from "../PrintableGradeRoster";
import PrintableClinicianCaseloads from "../PrintableClinicianCaseloads";

export default function GroupListsTab() {
  const [birthdays, setBirthdays] = useState([]);
  const [birthdayMonth, setBirthdayMonth] = useState("all");
  const birthdayReportRef = useRef(null);

  const fetchBirthdays = async () => {
    try {
      const res = await getBirthdays({ month: birthdayMonth !== "all" ? birthdayMonth : undefined });
      setBirthdays(res.data);
    } catch { toast.error("Failed to load birthdays"); }
  };

  return (
    <div className="space-y-6">
      <PrintableGroupLists />
      <PrintableGradeRoster />
      <PrintableClinicianCaseloads />
      <Card>
        <CardHeader><CardTitle>Birthday List</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex gap-4 items-end">
            <div className="space-y-2">
              <Label>Filter by Month</Label>
              <Select value={birthdayMonth} onValueChange={setBirthdayMonth}>
                <SelectTrigger className="w-[200px]"><SelectValue placeholder="All months" /></SelectTrigger>
                <SelectContent><SelectItem value="all">All Months</SelectItem>{[...Array(12)].map((_, i) => (<SelectItem key={`month-${i + 1}`} value={String(i + 1)}>{new Date(2000, i).toLocaleString("default", { month: "long" })}</SelectItem>))}</SelectContent>
              </Select>
            </div>
            <Button onClick={fetchBirthdays} className="bg-[#00305E] hover:bg-[#00305E]/90">Load Birthdays</Button>
            {birthdays.length > 0 && <Button variant="outline" onClick={() => printRef("Birthday List", birthdayReportRef)} data-testid="print-birthdays-btn"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect width="12" height="8" x="6" y="14"/></svg>Print</Button>}
          </div>
          {birthdays.length > 0 && (
            <div ref={birthdayReportRef} className="mt-4">
              <h2 className="font-semibold mb-4">Student Birthdays</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {birthdays.map((b, i) => (<div key={`${b.name}-${b.birthday}-${i}`} className="p-3 rounded-lg border"><p className="font-medium">{b.name}</p><p className="text-sm text-muted-foreground">{new Date(b.birthday).toLocaleDateString("en-US", { month: "long", day: "numeric" })}</p></div>))}
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
